<template>
  <div class="classrooms" style="min-height:50vw">
    <div class="container clearf">
      <div class="left-box">
        <div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>农技课堂</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="classroom">
          <ul class="clearf">
            <li
              class="classroom-item"
              v-for="(item, index) in list"
              :key="index"
              @click="problemClick(item)"
            >
              <a href="#">
                <div class="a-imgs">
                  <img
                    v-if="item.coverUrl"
                    class="item-bg"
                    :src="$img + item.coverUrl"
                  />
                  <img
                    v-if="!item.coverUrl"
                    class="item-bg"
                    src="../assets/briefDeafault.jpg"
                    alt=""
                  />
                  <img class="play" src="../assets/play.png" />
                </div>

                <div class="item-bottom">
                  <div class="classroom-title">{{ item.title }}</div>
                  <div class="classroom-time">
                    <span class="lefts">{{ item.publishDate }}</span>
                    <span
                      class="rights classroom-time-span"
                      style="font-size:12px;"
                      >{{ "阅读量:" + item.readingQuantity }}</span
                    >
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <div class="pagings" v-if="list.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="30"
            layout="total, prev, pager, next,jumper"
            :total="respData.totalElements"
          ></el-pagination>
        </div>
      </div>
      <div class="right-box">
        <recommendation />
      </div>
    </div>
  </div>
</template>

<script>
import recommendation from "../components/recommendation";
export default {
  data() {
    return {
      recommendation: "",
      pageSize: "30",
      pageNum: "1",
      list: "",
      currentPage1: 0
    };
  },
  components: {
    recommendation
  },
  mounted() {
    this.roomPage();
  },
  methods: {
    roomPage(obj) {
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$api.classroomApi
        .classPage(data)
        .then(res => {
          console.log("课堂列表", res);
          this.list = res.data.respData.content;
          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    problemClick(item) {
      let tid = item.tid;
      this.$router.push({
        path: "/classroomDetail",
        query: {
          tid: tid
        }
      });
      // this.$api.classroomApi
      //   .classDateil({ tid })
      //   .then(res => {
      //     console.log("课堂详情=>", res);
      //     this.$router.push({
      //       path: "/classroomDetail",
      //       query: {
      //         respData: res.data.respData
      //       }
      //     });
      //   })
      //   .catch(err => {
      //     console.log("err=>", err);
      //   });
    },

    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.roomPage();
      this.pageNum = "1";
    }
  }
};
</script>

<style lang="less">
.classroom {
  margin-top: 20px !important;
  ul {
    .classroom-item {
      float: left;
      width: 33.3%;
      padding: 0 8px 18px;
      a {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        .a-imgs {
          width: 100%;
          height: 167px;
          overflow: hidden;
          display: -webkit-flex;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;

          .item-bg {
            width: auto;
            height: 100%;
            margin: 0 auto 0;
          }
          .play {
            position: absolute;
            left: 50%;
            top: 60px;
            margin-left: -23px;
            width: 47px;
            height: 47px;
          }
        }

        .item-bottom {
          box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
          padding: 10px;
          .classroom-title {
            color: #333;
            font-size: 18px;
            padding: 10px 0;
            font-weight: 600;
            height: 44px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .classroom-time {
            font-size: 12px;
            color: #666;
            .lefts {
              display: inline-block;
              width: 60%;
            }
            .rights {
              display: inline-block;
              float: right;
            }
            .classroom-time-span {
              width: 40%;
              height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: right;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
.demonstration {
  color: #606626;
  font-size: 13px;
}
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/classroom.vue